import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setLoadingTxs(state, payload) {
    state.isLoadingTxs = payload;
  },
  setStartingDate(state, payload) {
    state.startingDate = payload;
  },
  setTokensChart(state, payload) {
    state.tokensChart = payload;
  },
  setTransactions(state, payload) {
    state.transactions = payload;
  },
  addTransactions(state, payload) {
    state.transactions.push(...payload);
  },
  setTxEventHeight(state, payload) {
    state.txEventHeight = payload;
  },
  setChartEventTokens(state, payload) {
    state.chartEventTokens = payload;
  },
};
